import options from './thing-location.component';

export default {
    selector: 'dtAsThingLocation',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-location/index.js